import { Injectable } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PosthogService {

  private initialized = false;

  constructor() {}

  initTracking() {
    if (this.initialized) return;
    posthog.init(environment.POSTHOG_API_KEY, {
      api_host: environment.POSTHOG_API_HOST,
      autocapture: true,
      capture_pageview: true,
      capture_performance: true,
      advanced_disable_toolbar_metrics: false,
    });

    this.initialized = true;
  }

  reset() {
    posthog.reset();
  }

  enableTracking() {
    posthog.opt_in_capturing();
  }

  disableTracking() {
    if (!posthog.__loaded) return;
    posthog.opt_out_capturing();
  }

  destroyTracking() {
    posthog.reset();
    this.initialized = false;

    Object.keys(localStorage).forEach(key => {
      if (key.startsWith("__ph")) {
        localStorage.removeItem(key);
      }
    });
  }
}
